import { Component, Inject, signal } from '@angular/core';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogClose,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'gosu-prompt',
  templateUrl: './prompt.dialog.html',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatDialogClose,
  ],
})
export class PromptDialog {
  public title = signal('');

  public label = signal('');

  public type = signal<'string' | 'number'>('string');

  public value = new FormControl<string | number>('', Validators.required);

  public form = new FormGroup({ value: this.value });

  public constructor(
    private _matDialogRef: MatDialogRef<PromptDialog>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      title: string;
      type: 'string' | 'number';
      label: string;
      defaultValue: string | number;
    },
  ) {
    this.title.set(data.title);
    this.type.set(data.type);
    this.label.set(data.label);
    this.value.setValue(data.defaultValue ?? '');
  }

  public onSubmit() {
    this._matDialogRef.close(this.value.value);
  }
}
